var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "questionMessage" },
    [
      _c("van-nav-bar", {
        attrs: {
          fixed: "",
          placeholder: "",
          "safe-area-inset-top": "",
          title: "我的消息",
          "left-text": "",
          "right-text": ""
        },
        on: {
          "click-left": _vm.handleClickLeft,
          "click-right": _vm.handleClickRight
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "questionMessage_tabs" },
        _vm._l(_vm.tabList, function(item, index) {
          return _c(
            "div",
            {
              key: index,
              class:
                item.value === _vm.tabSelect
                  ? "questionMessage_tabs_item active"
                  : "questionMessage_tabs_item",
              on: {
                click: function() {
                  return _vm.handleSelectTab(item.value)
                }
              }
            },
            [_vm._v("\n\t\t\t" + _vm._s(item.name) + "\n\t\t")]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "questionMessage_opration" }, [
        _c(
          "div",
          {
            staticClass: "questionMessage_opration_item",
            on: {
              click: function() {
                return _vm.handleRead()
              }
            }
          },
          [_vm._v("\n\t\t\t选中已读\n\t\t")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "questionMessage_opration_item",
            on: {
              click: function() {
                return _vm.handleRead("all")
              }
            }
          },
          [_vm._v("\n\t\t\t全部已读\n\t\t")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "questionMessage_opration_item",
            on: {
              click: function() {
                return _vm.handleDelete()
              }
            }
          },
          [_vm._v("\n\t\t\t选中删除\n\t\t")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "questionMessage_opration_item",
            on: {
              click: function() {
                return _vm.handleDelete("all")
              }
            }
          },
          [_vm._v("\n\t\t\t全部删除\n\t\t")]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "questionMessage_list" },
        [
          _c(
            "van-list",
            {
              attrs: {
                finished: _vm.pages.page >= _vm.pages.totalPages,
                "finished-text": "没有更多了"
              },
              on: { load: _vm.fetchList },
              model: {
                value: _vm.listLoading,
                callback: function($$v) {
                  _vm.listLoading = $$v
                },
                expression: "listLoading"
              }
            },
            _vm._l(_vm.list, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "questionMessage_item",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return function() {
                        return _vm.handleSelectItem(item.id)
                      }.apply(null, arguments)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "questionMessage_item_check" }, [
                    _c(
                      "div",
                      {
                        class: _vm.computedCheck(item.id)
                          ? "questionMessage_item_check_circle active"
                          : "questionMessage_item_check_circle"
                      },
                      [
                        _vm.computedCheck(item.id)
                          ? _c("van-icon", {
                              attrs: {
                                name: "checked",
                                size: ".19rem",
                                color: "#c32929"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "questionMessage_item_main" }, [
                    _c(
                      "div",
                      { staticClass: "questionMessage_item_main_info" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "questionMessage_item_main_info_title"
                          },
                          [
                            item.readStatus === 0
                              ? _c("div", {
                                  staticClass:
                                    "questionMessage_item_main_info_title_point"
                                })
                              : _vm._e(),
                            _vm._v(
                              "\n\t\t\t\t\t\t\t" +
                                _vm._s(item.title) +
                                "\n\t\t\t\t\t\t"
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "questionMessage_item_main_info_time"
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t" +
                                _vm._s(item.createTimeStr) +
                                "\n\t\t\t\t\t\t"
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "questionMessage_item_main_info_btn",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return function() {
                              return _vm.handleToRecord(item.id)
                            }.apply(null, arguments)
                          }
                        }
                      },
                      [_vm._v("\n\t\t\t\t\t\t查看及回复\n\t\t\t\t\t")]
                    )
                  ])
                ]
              )
            }),
            0
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("tabBar", { attrs: { active: 2 } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50072b13", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50072b13","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/question/message/index.vue
// module id = null
// module chunks = 